<template>
  <div class="sidebar-container" :class="{ floating }" v-show="$root.showSidebar">
    <div class="backdrop" @click="$root.showSidebar = false" />
    <div class="sidebar" @click="onClick">
      <div class="notepad" v-if="settings.notepadEnabled">
        <ItemHeader itemID="notepad" class="no-menu" defaultAction="open" />
        <button v-if="notepadContent" class="md-icon" @click="addNote">add</button>
      </div>
      <template v-if="settings.boardsEnabled">
        <div class="section-header">własne widoki</div>
        <SidebarTree itemType="layout" />
      </template>
      <div class="section-header">organizuj wg daty</div>
      <div
        class="combo-header"
        v-if="settings.oldCalendar"
        @click="$router.safePush('/view/old-calendar')"
      >
        <div class="md-icon">calendar_today</div>
        <div>Stary kalendarz</div>
      </div>
      <div class="combo-header" @click="$router.safePush('/view/calendar')">
        <div class="md-icon">calendar_today</div>
        <div>Kalendarz</div>
      </div>
      <SidebarTree v-if="settings.periodsEnabled" itemType="period" />
      <div class="section-header">organizuj wg tematu</div>
      <SidebarTree itemType="list" />
      <template v-if="settings.labelsEnabled">
        <div class="separator" />
        <SidebarTree itemType="label" />
      </template>
      <ItemHeader
        v-if="showOrphans"
        :itemID="unList"
        class="no-menu"
        defaultAction="open"
      />
    </div>
  </div>
</template>

<style scoped>
.combo-header {
  display: flex;
  align-items: center;
  & .md-icon {
    padding: var(--basic-padding);
    margin-left: 8px;
  }
}
.combo-header:hover {
  background: var(--bg-color-hover);
}
.sidebar-container {
  position: relative;
}

.floating.sidebar-container {
  position: absolute;
  height: 100%;
  width: 100%;
}

.backdrop {
  display: none;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.38);
}

.floating .backdrop {
  display: block;
}

.sidebar {
  position: relative;
  background-color: var(--sidebar-bg-color);
  height: 100%;
  width: 300px;
  z-index: 12;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  border-right: var(--topbar-border);
}

.floating .sidebar {
  background: var(--sidebar-bg-color-floating);
}

.notepad {
  display: flex;
}

.notepad .header {
  flex: 1;
}
.notepad button {
  padding: var(--basic-padding);
}

.section-header {
  display: flex;
  align-items: center;
  font-size: var(--text-size-tertiary);
  font-weight: bold;
  opacity: var(--text-opacity-quaternary);
}

.separator {
  height: 2px;
  background-color: var(--border-color1);
  margin: var(--basic-padding);
  opacity: var(--text-opacity-quaternary);
}

.section-header::before,
.section-header::after {
  content: "";
  flex: 1;
  height: 2px;
  background-color: var(--border-color1);
  margin: var(--basic-padding);
}

/* TODO: style reorganization - should this be here? */
.sidebar::v-deep .header {
  min-width: auto;
  padding-left: 8px;
}
.sidebar::v-deep .header:hover {
  background: var(--bg-color-hover);
}
</style>

<script>
import ItemHeader from "./ItemHeader.vue";
import { defaultListID } from "../structure";
import { getItem } from "@/reactive-cache";
import settings from "@/synced-settings";
import SidebarTree from "./SidebarTree.vue";

export default {
  components: {
    ItemHeader,
    SidebarTree,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      unList: defaultListID,
      settings: settings,
    };
  },
  computed: {
    floating() {
      // 920 - less than half of FHD display (with 80px margin for system sidebar)
      return this.$root.isMobile || this.windowWidth < 920;
    },
    showOrphans() {
      return settings.showOrphans;
    },
    notepadContent() {
      return getItem("notepad").getChildren().length > 1;
    },
  },
  methods: {
    onClick() {
      if (this.floating) {
        this.$root.showSidebar = false;
      }
    },
    addNote() {
      getItem("notepad").createChild("note", "Dodaj notatkę do notatnika:");
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
      this.$root.showSidebar = !this.floating;
    });
  },
};
</script>
